import { render, staticRenderFns } from "./ProductInfoGroups.vue?vue&type=template&id=3a3b8d14"
import script from "./ProductInfoGroups.vue?vue&type=script&lang=ts"
export * from "./ProductInfoGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3b8d14')) {
      api.createRecord('3a3b8d14', component.options)
    } else {
      api.reload('3a3b8d14', component.options)
    }
    module.hot.accept("./ProductInfoGroups.vue?vue&type=template&id=3a3b8d14", function () {
      api.rerender('3a3b8d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoGroups.vue"
export default component.exports